import axios from 'axios';
import * as api from './constants';

export function generateOtp(phoneNumber) {
  return axios
    .post(
      api.FORGOT_PASSWORD_OTP_URL,
      { phone: phoneNumber },
      { withCredentials: false }
    )
    .catch(error => {
      return Promise.reject(new Error(error.response.data.message));
    });
}
export function verfyPasswordOtp(data) {
  return axios.post(api.FORGOT_PASSWORD_VERIFY_OTP_URL, data, {
    withCredentials: false,
  });
}
